import React, { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Country code to timezone mapping (common primary timezones)
const COUNTRY_TIMEZONES = {
    'AD': 'Europe/Andorra',
    'AE': 'Asia/Dubai',
    'AF': 'Asia/Kabul',
    'AG': 'America/Antigua',
    'AI': 'America/Anguilla',
    'AL': 'Europe/Tirane',
    'AM': 'Asia/Yerevan',
    'AO': 'Africa/Luanda',
    'AR': 'America/Argentina/Buenos_Aires',
    'AS': 'Pacific/Pago_Pago',
    'AT': 'Europe/Vienna',
    'AU': 'Australia/Sydney',
    'AW': 'America/Aruba',
    'AX': 'Europe/Mariehamn',
    'AZ': 'Asia/Baku',
    'BA': 'Europe/Sarajevo',
    'BB': 'America/Barbados',
    'BD': 'Asia/Dhaka',
    'BE': 'Europe/Brussels',
    'BF': 'Africa/Ouagadougou',
    'BG': 'Europe/Sofia',
    'BH': 'Asia/Bahrain',
    'BI': 'Africa/Bujumbura',
    'BJ': 'Africa/Porto-Novo',
    'BL': 'America/St_Barthelemy',
    'BM': 'Atlantic/Bermuda',
    'BN': 'Asia/Brunei',
    'BO': 'America/La_Paz',
    'BQ': 'America/Kralendijk',
    'BR': 'America/Sao_Paulo',
    'BS': 'America/Nassau',
    'BT': 'Asia/Thimphu',
    'BW': 'Africa/Gaborone',
    'BY': 'Europe/Minsk',
    'BZ': 'America/Belize',
    'CA': 'America/Toronto',
    'CC': 'Indian/Cocos',
    'CD': 'Africa/Kinshasa',
    'CF': 'Africa/Bangui',
    'CG': 'Africa/Brazzaville',
    'CH': 'Europe/Zurich',
    'CI': 'Africa/Abidjan',
    'CK': 'Pacific/Rarotonga',
    'CL': 'America/Santiago',
    'CM': 'Africa/Douala',
    'CN': 'Asia/Shanghai',
    'CO': 'America/Bogota',
    'CR': 'America/Costa_Rica',
    'CU': 'America/Havana',
    'CV': 'Atlantic/Cape_Verde',
    'CW': 'America/Curacao',
    'CX': 'Indian/Christmas',
    'CY': 'Asia/Nicosia',
    'CZ': 'Europe/Prague',
    'DE': 'Europe/Berlin',
    'DJ': 'Africa/Djibouti',
    'DK': 'Europe/Copenhagen',
    'DM': 'America/Dominica',
    'DO': 'America/Santo_Domingo',
    'DZ': 'Africa/Algiers',
    'EC': 'America/Guayaquil',
    'EE': 'Europe/Tallinn',
    'EG': 'Africa/Cairo',
    'EH': 'Africa/El_Aaiun',
    'ER': 'Africa/Asmara',
    'ES': 'Europe/Madrid',
    'ET': 'Africa/Addis_Ababa',
    'FI': 'Europe/Helsinki',
    'FJ': 'Pacific/Fiji',
    'FK': 'Atlantic/Stanley',
    'FM': 'Pacific/Pohnpei',
    'FO': 'Atlantic/Faroe',
    'FR': 'Europe/Paris',
    'GA': 'Africa/Libreville',
    'GB': 'Europe/London',
    'GD': 'America/Grenada',
    'GE': 'Asia/Tbilisi',
    'GF': 'America/Cayenne',
    'GG': 'Europe/Guernsey',
    'GH': 'Africa/Accra',
    'GI': 'Europe/Gibraltar',
    'GL': 'America/Godthab',
    'GM': 'Africa/Banjul',
    'GN': 'Africa/Conakry',
    'GP': 'America/Guadeloupe',
    'GQ': 'Africa/Malabo',
    'GR': 'Europe/Athens',
    'GT': 'America/Guatemala',
    'GU': 'Pacific/Guam',
    'GW': 'Africa/Bissau',
    'GY': 'America/Guyana',
    'HK': 'Asia/Hong_Kong',
    'HN': 'America/Tegucigalpa',
    'HR': 'Europe/Zagreb',
    'HT': 'America/Port-au-Prince',
    'HU': 'Europe/Budapest',
    'ID': 'Asia/Jakarta',
    'IE': 'Europe/Dublin',
    'IL': 'Asia/Jerusalem',
    'IM': 'Europe/Isle_of_Man',
    'IN': 'Asia/Kolkata',
    'IO': 'Indian/Chagos',
    'IQ': 'Asia/Baghdad',
    'IR': 'Asia/Tehran',
    'IS': 'Atlantic/Reykjavik',
    'IT': 'Europe/Rome',
    'JE': 'Europe/Jersey',
    'JM': 'America/Jamaica',
    'JO': 'Asia/Amman',
    'JP': 'Asia/Tokyo',
    'KE': 'Africa/Nairobi',
    'KG': 'Asia/Bishkek',
    'KH': 'Asia/Phnom_Penh',
    'KI': 'Pacific/Kiritimati',
    'KM': 'Indian/Comoro',
    'KN': 'America/St_Kitts',
    'KP': 'Asia/Pyongyang',
    'KR': 'Asia/Seoul',
    'KW': 'Asia/Kuwait',
    'KY': 'America/Cayman',
    'KZ': 'Asia/Almaty',
    'LA': 'Asia/Vientiane',
    'LB': 'Asia/Beirut',
    'LC': 'America/St_Lucia',
    'LI': 'Europe/Vaduz',
    'LK': 'Asia/Colombo',
    'LR': 'Africa/Monrovia',
    'LS': 'Africa/Maseru',
    'LT': 'Europe/Vilnius',
    'LU': 'Europe/Luxembourg',
    'LV': 'Europe/Riga',
    'LY': 'Africa/Tripoli',
    'MA': 'Africa/Casablanca',
    'MC': 'Europe/Monaco',
    'MD': 'Europe/Chisinau',
    'ME': 'Europe/Podgorica',
    'MF': 'America/Marigot',
    'MG': 'Indian/Antananarivo',
    'MH': 'Pacific/Majuro',
    'MK': 'Europe/Skopje',
    'ML': 'Africa/Bamako',
    'MM': 'Asia/Yangon',
    'MN': 'Asia/Ulaanbaatar',
    'MO': 'Asia/Macau',
    'MP': 'Pacific/Saipan',
    'MQ': 'America/Martinique',
    'MR': 'Africa/Nouakchott',
    'MS': 'America/Montserrat',
    'MT': 'Europe/Malta',
    'MU': 'Indian/Mauritius',
    'MV': 'Indian/Maldives',
    'MW': 'Africa/Blantyre',
    'MX': 'America/Mexico_City',
    'MY': 'Asia/Kuala_Lumpur',
    'MZ': 'Africa/Maputo',
    'NA': 'Africa/Windhoek',
    'NC': 'Pacific/Noumea',
    'NE': 'Africa/Niamey',
    'NF': 'Pacific/Norfolk',
    'NG': 'Africa/Lagos',
    'NI': 'America/Managua',
    'NL': 'Europe/Amsterdam',
    'NO': 'Europe/Oslo',
    'NP': 'Asia/Kathmandu',
    'NR': 'Pacific/Nauru',
    'NU': 'Pacific/Niue',
    'NZ': 'Pacific/Auckland',
    'OM': 'Asia/Muscat',
    'PA': 'America/Panama',
    'PE': 'America/Lima',
    'PF': 'Pacific/Tahiti',
    'PG': 'Pacific/Port_Moresby',
    'PH': 'Asia/Manila',
    'PK': 'Asia/Karachi',
    'PL': 'Europe/Warsaw',
    'PM': 'America/Miquelon',
    'PN': 'Pacific/Pitcairn',
    'PR': 'America/Puerto_Rico',
    'PS': 'Asia/Gaza',
    'PT': 'Europe/Lisbon',
    'PW': 'Pacific/Palau',
    'PY': 'America/Asuncion',
    'QA': 'Asia/Qatar',
    'RE': 'Indian/Reunion',
    'RO': 'Europe/Bucharest',
    'RS': 'Europe/Belgrade',
    'RU': 'Europe/Moscow',
    'RW': 'Africa/Kigali',
    'SA': 'Asia/Riyadh',
    'SB': 'Pacific/Guadalcanal',
    'SC': 'Indian/Mahe',
    'SD': 'Africa/Khartoum',
    'SE': 'Europe/Stockholm',
    'SG': 'Asia/Singapore',
    'SH': 'Atlantic/St_Helena',
    'SI': 'Europe/Ljubljana',
    'SJ': 'Arctic/Longyearbyen',
    'SK': 'Europe/Bratislava',
    'SL': 'Africa/Freetown',
    'SM': 'Europe/San_Marino',
    'SN': 'Africa/Dakar',
    'SO': 'Africa/Mogadishu',
    'SR': 'America/Paramaribo',
    'SS': 'Africa/Juba',
    'ST': 'Africa/Sao_Tome',
    'SV': 'America/El_Salvador',
    'SX': 'America/Lower_Princes',
    'SY': 'Asia/Damascus',
    'SZ': 'Africa/Mbabane',
    'TC': 'America/Grand_Turk',
    'TD': 'Africa/Ndjamena',
    'TF': 'Indian/Kerguelen',
    'TG': 'Africa/Lome',
    'TH': 'Asia/Bangkok',
    'TJ': 'Asia/Dushanbe',
    'TK': 'Pacific/Fakaofo',
    'TL': 'Asia/Dili',
    'TM': 'Asia/Ashgabat',
    'TN': 'Africa/Tunis',
    'TO': 'Pacific/Tongatapu',
    'TR': 'Europe/Istanbul',
    'TT': 'America/Port_of_Spain',
    'TV': 'Pacific/Funafuti',
    'TW': 'Asia/Taipei',
    'TZ': 'Africa/Dar_es_Salaam',
    'UA': 'Europe/Kiev',
    'UG': 'Africa/Kampala',
    'US': 'America/New_York',
    'UY': 'America/Montevideo',
    'UZ': 'Asia/Tashkent',
    'VA': 'Europe/Vatican',
    'VC': 'America/St_Vincent',
    'VE': 'America/Caracas',
    'VG': 'America/Tortola',
    'VI': 'America/St_Thomas',
    'VN': 'Asia/Ho_Chi_Minh',
    'VU': 'Pacific/Efate',
    'WF': 'Pacific/Wallis',
    'WS': 'Pacific/Apia',
    'YE': 'Asia/Aden',
    'YT': 'Indian/Mayotte',
    'ZA': 'Africa/Johannesburg',
    'ZM': 'Africa/Lusaka',
    'ZW': 'Africa/Harare'
};
const TimeDifferenceWidget = () => {
    const [userData, setUserData] = useState(null);
    const [partnerData, setPartnerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        // Update time every second
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const auth = getAuth();
                const user = auth.currentUser;

                if (!user) {
                    setError("You must be logged in");
                    setLoading(false);
                    return;
                }

                const db = getFirestore();
                const userDocRef = doc(db, "UserInformation", user.uid);
                const userSnapshot = await getDoc(userDocRef);

                if (!userSnapshot.exists()) {
                    setError("User information not found");
                    setLoading(false);
                    return;
                }

                const userInfo = userSnapshot.data();
                setUserData(userInfo);

                if (userInfo.inRelation && userInfo.inRelationWith) {
                    const partnerDocRef = doc(db, "UserInformation", userInfo.inRelationWith);
                    const partnerSnapshot = await getDoc(partnerDocRef);

                    if (partnerSnapshot.exists()) {
                        setPartnerData(partnerSnapshot.data());
                    }
                }

                setLoading(false);
            } catch (err) {
                console.error("Error fetching user data:", err);
                setError("Failed to load data");
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const getTimezoneFromCountry = (countryCode, fallbackTimeZone) => {
        // Use country code to get timezone, or fallback to city timezone if available
        return COUNTRY_TIMEZONES[countryCode] || fallbackTimeZone || 'UTC';
    };

    const calculateTimeDifference = () => {
        if (!userData || !partnerData) return null;

        // Get timezones from country codes with fallbacks
        const userTimeZone = getTimezoneFromCountry(
            userData.countryCode,
            userData.city?.timeZone
        );

        const partnerTimeZone = getTimezoneFromCountry(
            partnerData.countryCode,
            partnerData.city?.timeZone
        );

        const userOptions = { timeZone: userTimeZone };
        const partnerOptions = { timeZone: partnerTimeZone };

        // Calculate hour difference
        const userDate = new Date(currentTime.toLocaleString('en-US', userOptions));
        const partnerDate = new Date(currentTime.toLocaleString('en-US', partnerOptions));
        const diffInHours = Math.round((partnerDate - userDate) / (1000 * 60 * 60));

        return {
            diffInHours,
            userTimeZone,
            partnerTimeZone
        };
    };

    // Calculate time difference when currentTime updates
    const timeInfo = calculateTimeDifference();

    if (loading) {
        return (
            <div className="widget time-difference-widget">
                <div className="time-difference-loading">
                    <h4>Time Difference</h4><div className="loading">Loading...</div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="widget time-difference-widget">
                <div className="time-difference-error">
                    <h4>Time Difference</h4>
                    <div className="error-message">{error}</div>
                </div>
            </div>
        );
    }

    if (!userData?.inRelation || !partnerData) {
        return (
            <div className="widget time-difference-widget">
                <div className="time-difference-no-connection">
                    <h4>Time Difference</h4>
                    <div className="error-message">You must be connected with someone to use this widget</div>
                </div>
            </div>
        );
    }

    return (
        <div className="widget time-difference-widget">
            <div className="time-difference">
                {timeInfo && (
                    <span>
                        <strong>Time Difference:</strong> {timeInfo.diffInHours === 0
                        ? "0 hours"
                        : `${timeInfo.diffInHours > 0 ? '+' : ''}${timeInfo.diffInHours} hours`}
                    </span>
                )}
            </div>
        </div>
    );
};

export default TimeDifferenceWidget;